var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"pt-2",attrs:{"loading":_vm.loading},model:{value:(_vm.notificationsEnabled),callback:function ($$v) {_vm.notificationsEnabled=$$v},expression:"notificationsEnabled"}})}
var staticRenderFns = []

export { render, staticRenderFns }